import { styled } from "@mui/material/styles";
import ErrorIcon from "@mui/icons-material/Error";
import { red } from "designSystem/styles/color";
import { Box, FlexRowCenter, OverflowText } from "designSystem/index";
import { TextProps } from "designSystem/components/text/Text";
import React, { FunctionComponent } from "react";

const PREFIX = "PPInvalidTag";

const classes = {
	icon: `${PREFIX}icon`,
	message: `${PREFIX}message`,
	root: `${PREFIX}root`,
};

const StyledFlexRowCenter = styled(FlexRowCenter)(({
	theme: { spacing },
}) => ({
	[`& .${classes.icon}`]: {
		color: red[500],
		marginLeft: spacing(1),
		marginRight: spacing(1),
		marginTop: spacing(0.5),
		marginBottom: spacing(0.5),
	},

	[`& .${classes.message}`]: {
		color: red[900],
	},

	[`&.${classes.root}`]: {
		borderTopLeftRadius: 0,
		borderTopRightRadius: 3,
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 3,
		backgroundColor: red[100],
		height: 20,
		paddingRight: 4,
	},
}));

interface PPInvalidTagProps extends Omit<TextProps, "semiBold"> {

}

const PPInvalidTag: FunctionComponent<PPInvalidTagProps> = (props: PPInvalidTagProps) => {
	const { icon, message, root } = classes;

	return (
		<StyledFlexRowCenter className={root}>
			<Box>
				<ErrorIcon className={icon} />
			</Box>
			<Box className={message} flexGrow={1}>
				<OverflowText semiBold {...props} />
			</Box>
		</StyledFlexRowCenter>
	);
};

export default PPInvalidTag;